module.exports = __webpack_public_path__ + "img/placeholder.1eb7fff2.jpg";